export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/forte-icon.svg?ef1c62d5b5ee456feeda9c3a899fd091";